import { VTabs } from 'vuetify/lib'

export default {
  inheritAttrs: false,
  components: {
    VTabs
  },
  computed: {
    classes () {
      return ''
    },

    commonAttrs () {
      return {
        'background-color': 'table',
        'active-class': 'active-tab'
      }
    },

    overrideAttrs () {
      return {
      }
    }
  }
}
